"use client";

import Container from "@mui/material/Container";
import { Header } from "modules/shared/page/header";

export const PrivacyPolicy = () => {
  return (
    <>
      <Header landingMode />
      <Container
        sx={{
          td: { px: 2.5, border: "solid 1px black" },
          th: {
            px: 2.5,
            borderTop: "solid 1px black",
            borderRight: "solid 1px black",
            borderLeft: "solid 1px black",
          },
          table: { borderCollapse: "collapse" },
        }}
      >
        <h1>1. Applicability</h1>
        <p>
          1.1 This Privacy Policy applies to all Websites, Mobile Applications,
          and other electronic means of service (“Platform”) owned and operated
          by PROMTECH SOLUTIONS LTD (“PROMTECH”).
        </p>
        <p>
          1.2 PROMTECH SOLUTIONS LTD is a company incorporated under the laws of
          the British Virgin Islands (BVI) with the registration number 215954.
          The legal address (“Registered Office”) of PROMTECH is 1st Floor,
          Columbus Centre, PO Box 2283, Road Town, Tortola VG 1110, British
          Virgin Islands.
        </p>
        <h1>2. Scope of Policy </h1>
        <p>
          2.1 The provisions herein constitute the regulatory framework of the
          collection, usage, control, and retention of personal information
          about users (“You”) of the Platform.
        </p>
        <p>
          2.2 This Privacy Policy does neither apply to data collected by any
          other means than accessing and using the Platform nor to data
          collected by third parties. The use of collected information shall be
          limited exclusively to the purposes defined under this Privacy Policy.{" "}
        </p>
        <p>
          2.3 This Privacy Policy supplements other notices and regulations
          issued by PROM, including its Terms of Service, and is not intended to
          override them.
        </p>
        <h1>Data Protection Officer</h1>
        <p>
          Data Protection Officer PROMTECH has appointed a Data Protection
          Officer (“DPO”) who is responsible for overseeing questions in
          relation to this Privacy Policy. If You have any questions about this
          Privacy Policy, including any requests to exercise Your rights, please
          contact the DPO using the following contact details:
        </p>
        <p>
          Attn. Data Protection Officer PROMTECH SOLUTIONS LTD 1st Floor,
          Columbus Centre, PO Box 2283 Road Town, Tortola VG 1110, British
          Virgin Islands Email: dpo@prom.io
        </p>
        <h1>4. User Rights </h1>
        To review, correct, update, or delete inaccuracies regarding the
        information about You that PROMTECH stores, please contact PROMTECH
        directly at dpo@prom.io. PROMTECH will address Your request within
        seventy-two hours. While local data protection laws in the British
        Virgin Islands may not specifically mandate certain rights, PROMTECH
        adheres to international best practices and offers You the following
        rights regarding Your personal data:
        <p>
          4.1 You have the right to request that PROMTECH rectifies or deletes
          personal data or restricts the processing of Your personal data if You
          believe it is inaccurate or being processed unlawfully.
        </p>
        <p>
          4.2 You have the right to object to the processing of Your personal
          data if it is based on PROMTECH&apos;s legitimate interests. PROMTECH
          will assess and act on Your request. If applicable, You may also have
          the right to data portability.
        </p>
        <p>
          4.3 If You are located in a jurisdiction that provides additional data
          protection rights, PROMTECH will endeavor to comply with such rights
          where feasible.
        </p>
        <p>
          4.4 If You have concerns about how PROMTECH is handling Your personal
          data, please contact us at dpo@prom.io.
        </p>
        <h1>5. Dispute Resolution</h1>
        <p>
          PROMTECH is committed to addressing questions or concerns about Your
          privacy and the collection or use of Your personal information. Users
          with questions or concerns about the use of their personal data should
          contact PROMTECH at: dpo@prom.io.
          <p>
            If Your question or concern cannot be resolved through this process,
            You may pursue resolution through independent arbitration or legal
            action in the British Virgin Islands, in accordance with local laws.
          </p>
          <p>
            If You are located in a jurisdiction that provides access to
            supervisory authorities or similar oversight mechanisms for privacy
            concerns, PROMTECH will cooperate with such authorities as required.
          </p>
        </p>
        <h1>6. Collected Data</h1>
        <h3>6.1 Non-Personally Identifiable Information </h3>
        <p>
          PROM collects Non-personally Identifiable Information (“Non-PII”)
          about users of the Platform. This information may be used for
          analyzing trends, administering the Platform, saving user settings,
          authentication, tracking user behavior around the Platform and
          gathering general demographic information about the userbase. For more
          general information or instructions on how to opt-out, please contact
          the Data Protection Officer at dpo@prom.io.
        </p>
        <h3>6.2 Personally Identifiable Information </h3>
        <p>
          Upon registration on the Platform, PROM may, in addition to the
          information collected about visitors, also collect Personally
          Identifiable Information (“PII”) about You:{" "}
        </p>
        <ul>
          <li>
            <b>Identity Data </b>
            includes first name, last name, username or similar identifier, date
            and place of birth, citizenship, and gender.
          </li>
          <li>
            <b>Verification Data </b>
            includes proof of identity (passport or national ID), proof of
            address (utility bill, government issued document or bank statement)
            and a self-portrait photograph.
          </li>
          <li>
            <b>Contact Data </b>
            includes billing address, email address and telephone number(s).
          </li>
          <li>
            <b>Transaction Data </b>
            includes details about payments to and from You and other details of
            products and services You have purchased from PROM.
          </li>
          <li>
            <b>Technical Data </b>
            includes internet protocol (IP) address, Your login data, browser
            type and version, time zone setting and location, browser plug-in
            types and versions, operating system and platform, and other
            technology on the devices You use to access the Platform.
          </li>
          <li>
            <b>Profile Data </b>
            includes Your username and password, purchases or orders made by
            You, Your interests, preferences, feedback, and survey responses.
          </li>
          <li>
            <b>Usage Data </b>
            includes information about how You use the Platform including any
            products and services offered by PROM.
          </li>
          <li>
            <b>Marketing and Communications Data </b>
            includes Your preferences in receiving marketing from PROM and their
            third parties and Your communication preferences.
          </li>
        </ul>
        <h3>6.3 Aggregated Data</h3>
        <p>
          PROM also collects, uses and shares Aggregated Data such as
          statistical or demographic data where deemed necessary. Aggregated
          Data could be derived from Your personal data but is not considered
          personal data in law as this data will not directly or indirectly
          reveal Your identity. For example, PROM may aggregate Your Usage Data
          to calculate the percentage of users accessing a specific website
          feature. However, if PROM combines or connects Aggregated Data with
          Your personal data so that it can directly or indirectly identify You,
          we treat the combined data as personal data which will be used in
          accordance with this Privacy Policy.
        </p>
        <h3>6.4 Special Categories of Personal Data</h3>
        <p>
          PROM does not collect any Special Categories of Personal Data about
          You (this includes details about Your race or ethnicity, religious or
          philosophical beliefs, sex life, sexual orientation, political
          opinions, trade union membership, information about Your health, and
          genetic and biometric data, data on criminal convictions and offenses.
        </p>
        <h3>6.5 Children&apos;s Privacy </h3>
        <p>
          PROM does not knowingly collect or solicit personal information from
          anyone under the age of 13. In the event that PROM gets to know about
          the collection of personal information from a child under age 13, PROM
          will delete that information as quickly as possible. If You believe
          that PROM might have any information from or about a child under 13,
          please send an email to dpo@prom.io.
        </p>
        <h3>6.6 Data Accuracy</h3>
        <p>
          It is important that the personal data PROM holds about You is
          accurate and current. Please keep PROM informed if Your personal data
          changes or if You become aware that any personal data that PROM holds
          about You is not accurate.
        </p>
        <h3>6.7 Failure to Provide Personal Data</h3>
        <p>
          Where PROM needs to collect personal data by law, or under the terms
          of a contract PROM has with You, and You fail to provide that data
          when requested, PROM may not be able to perform the contract (for
          example, to provide You with services). In this case, PROM may have to
          cancel a product or service provided to You. In that event, PROM will
          notify You at the time.{" "}
        </p>
        <h1>7. Data Collection Methods</h1>
        <p>
          PROM may use each or any of the following methods to collect each or
          any of the data specified in section 6 from and about You:{" "}
        </p>
        <h3>7.1 Direct Interactions </h3>
        <p>
          You may provide PROM with Your Identity Data, Verification Data, and
          Contact Data by filling in forms or by corresponding with PROM by
          post, phone, email, or other means of communication. This includes
          personal data You provide when You:
        </p>
        <ul>
          <li>apply for PROM&apos;s products or services; </li>
          <li>create an account on the Platform; </li>
          <li>subscribe to any service or publications by PROM; </li>
          <li>request marketing to be sent to You; </li>
          <li>enter a competition, promotion, or survey; or </li>
          <li>give feedback or contact PROM. </li>
        </ul>
        <h3>7.2 Automated Technologies or Interactions </h3>
        <p>
          As You interact with the Platform, PROM will automatically collect
          Technical Data about Your equipment, browsing actions and patterns.
          PROM collects this data by using cookies, server logs and other
          similar technologies. PROM may also receive Technical Data about You
          if You visit other websites employing cookies by PROM.
        </p>
        <p>
          7.2.1 The platform uses cookies to distinguish You from other users of
          the Platform. This helps PROM to provide You with a good experience
          when You browse the Platform and allows PROM to improve the Platform.
        </p>
        <p>
          7.2.2 A cookie is a small file of letters and numbers that is stored
          on Your browser or the hard drive of Your computer if You agree.
          Cookies contain information that is transferred to Your computer`s
          hard drive.
        </p>
        <p>
          7.2.3 You can block cookies by activating the setting on Your browser
          that allows You to refuse the setting of all or some cookies. However,
          if You use Your browser settings to block all cookies (including
          essential cookies) You may not be able to access all or parts of the
          Platform.
        </p>
        <p>
          7.2.4 Most of the cookies we use on our website are
          &apos;persistent&apos; cookies. This means that they remain on Your
          device until You erase them, or they expire. The rest of these cookies
          are &apos;session&apos; based which are more temporary in duration.
          This means they will be erased when You close Your internet browser.
        </p>
        <p>7.2.5 PROM uses the following cookies:</p>
        <ul>
          <li>
            <b>Strictly necessary cookies.</b> These are cookies that are
            required for the operation of the Platform. They include, for
            example, cookies that enable You to log into secure areas of the
            PROM website.{" "}
          </li>
          <li>
            <b>Analytical or performance cookies.</b> These allow PROM to
            recognize and count the number of visitors and to see how visitors
            move around the Platform when they are using it. This helps PROM to
            improve the way its website works, for example, by ensuring that
            users are finding what they are looking for easily.{" "}
          </li>
          <li>
            <b>Functionality cookies. </b>These are used to recognize You when
            You return to the Platform. This enables PROM to personalize the
            Platform content for You, greet You by name and remember Your
            preferences (for example, Your choice of language or region).{" "}
          </li>
          <li>
            <b>Targeting cookies. </b>These cookies record Your visit to the
            Platform, the pages You have visited and the links You have
            followed. PROM will use this information to make its website and the
            advertising displayed on it more relevant to Your interests. PROM
            may also share this information with third parties for this purpose.{" "}
          </li>
        </ul>
        <p>
          7.2.6 Below you can find a list of the individual cookies used and the
          purposes for which PROM uses them:
        </p>
        <table>
          <tr>
            <th>Cookie Name</th>
            <th>Purpose</th>
          </tr>
          <tr>
            <td>Avax</td>
            <td>
              This cookie, set by Cloudflare, is used to support Cloudflare Bot
              Management.
            </td>
          </tr>
          <tr>
            <td>Github</td>
            <td>
              Github is a distributed version-control platform where users can
              collaborate on or adoptopen source code projects, fork code, share
              ideas and more
            </td>
          </tr>
        </table>
        <p>
          7.2.7 Third parties (including, for example, advertising networks and
          providers of external services like user traffic analysis services)
          may also use cookies, over which PROM has no control. These cookies
          are likely to be analytical, performance or targeting cookies.
        </p>
        <p>
          7.2.8 If You are unclear about the types of functions of cookies used
          on the Platform, please contact PROM at dpo@prom.io
        </p>
        <h3>7.3 Third Parties or Publicly Available Sources </h3>
        <p>
          PROM may receive personal data about You from various third parties
          and public sources as set out below:
        </p>
        <ul>
          <li>
            <b>Technical Data </b>
            rom the following parties: analytics providers such as Google based
            outside the European Union; advertising networks including but not
            limited to Google, Twitter, Facebook, Linkedin; search information
            providers such as Google.com and Bing.com.
          </li>
          <li>
            <b>Contact Data </b> and <b>Transaction Data </b> from providers of
            technical, payment and/or delivery services such as SWIFT, SEPA.
          </li>
          <li>
            <b>Identity Data, Verification Data </b> and <b>Contact Data </b>{" "}
            from data brokers or aggregators.
          </li>
          <li>
            <b>Identity Data </b> and <b>Contact Data </b> from publicly
            available sources.
          </li>
        </ul>
        <h1>8. Use of Collected Data </h1>
        <p>
          PROM uses the collected information to operate and maintain the
          Platform, to interact with its users and to ensure compliance with
          Know Your Customer (KYC) regulations. The lawful basis for this use of
          personal data is art. 6(1)(f) of the EU General Data Protection
          Regulation (GDPR).
        </p>
        <p>
          Most commonly, PROM will use Your personal data in the following
          circumstances:
        </p>
        <ul>
          <li>
            Where PROM needs to perform the contract that PROM is about to enter
            into or have entered into with You.{" "}
          </li>
          <li>
            Where it is necessary for legitimate interests of PROM (or those of
            a third party) and where Your interests and fundamental rights do
            not override those interests.{" "}
          </li>
          <li>Where PROM needs to comply with a legal obligation. </li>
        </ul>
        <p>
          Generally, PROM does not rely on consent as a legal basis for
          processing Your personal data although PROM will get Your consent
          before sending third party direct marketing communications to You via
          email or text message. You have the right to withdraw consent to
          marketing at any time by contacting PROM at dpo@prom.io.
        </p>
        <h3>8.1 General Purposes of Data Usage </h3>
        <p>
          A description of all the ways PROM may use Your personal data
          including their legal bases is set out below. PROM may process Your
          personal data for more than one lawful ground depending on the
          specific purpose which Your data are used for. In case You require
          further details about the specific lawful basis on which PROM is
          relying in order to process Your personal data where more than one
          lawful basis has been set out in the table below, please contact PROM
          at info@prom.io.
        </p>
        <table>
          <tr>
            <th>Purpose/Activity</th>
            <th>Type of data</th>
            <th>
              Lawful basis for processing including basis of legitimate interest
            </th>
          </tr>
          <tr>
            <td>To register You as a new customer</td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Verification</li>
                <li>Contact</li>
                <li>Marketing and Communications</li>
              </ol>
            </td>
            <td>
              <ol type="a">
                <li>Performance of a contract with You</li>
                <li>Necessary for PROM&apos;s legitimate interests</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>
              To manage PROM&apos;s relationship with You which will include:
              <ol type="a">
                <li>
                  {" "}
                  Notifying You about changes to the Terms of Service or the
                  Privacy Policy
                </li>
                <li>Asking You to leave a review or take a survey</li>
              </ol>
            </td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Contact</li>
                <li>Profile</li>
                <li>Marketing and Communications</li>
              </ol>
            </td>
            <td>
              <ol type="a">
                <li>Performance of a contract with You</li>
                <li>
                  Performance of a contract with You Necessary to comply with a
                  legal obligation
                </li>
                <li>
                  Necessary for PROM&apos;s legitimate interests (to keep
                  records updated and to study how customers use PROM&apos;s
                  products/services)
                </li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>
              To enable You to partake in a prize draw, competition or complete
              a survey{" "}
            </td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Contact</li>
                <li>Profile</li>
                <li>Marketing and Communications</li>
              </ol>
            </td>
            <td>
              <ol type="a">
                <li>Performance of a contract with You</li>
                <li>
                  Performance of a contract with You Necessary to comply with a
                  legal obligation
                </li>
                <li>
                  Necessary for PROM&apos;s legitimate interests ((to study how
                  customers use PROM&apos;s products/services, to develop them
                  and grow the business)
                </li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>
              To administer and protect PROM&apos;s business and website
              (including troubleshooting, data analysis, testing, system
              maintenance, support, reporting and hosting of data){" "}
            </td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Company</li>
                <li>Contact</li>
                <li>Technical</li>
              </ol>
            </td>
            <td>
              <ol type="a">
                <li>
                  Necessary for PROM&apos;s legitimate interests (for running
                  the business, provision of administration and IT services,
                  network security, to prevent fraud and in the context of a
                  business reorganization or group restructuring exercise)
                </li>
                <li>Necessary to comply with a legal obligation</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>
              To deliver relevant website content and advertisements to You and
              measure or understand the effectiveness of the advertising served
              to You{" "}
            </td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Company</li>
                <li>Contact</li>
                <li>Profile</li>
                <li>Usage</li>
                <li>Marketing and Communications</li>
                <li>Technical</li>
              </ol>
            </td>
            <td>
              Necessary for PROM&apos;s legitimate interests (to study how
              customers use the products/services, to develop them, to grow the
              business and to adjust the marketing strategy){" "}
            </td>
          </tr>
          <tr>
            <td>
              To use data analytics to improve PROM&apos;s website,
              products/services, marketing, customer relationships and
              experiences{" "}
            </td>
            <td>
              <ol type="a">
                <li>Technical</li>
                <li>Usage</li>
              </ol>
            </td>
            <td>
              Necessary for PROM&apos;s legitimate interests (to define types of
              customers for products and services, to keep the website updated
              and relevant, to develop the business and to adjust the marketing
              strategy){" "}
            </td>
          </tr>
          <tr>
            <td>
              To make suggestions and recommendations to You about goods or
              services that may be of interest to You{" "}
            </td>
            <td>
              <ol type="a">
                <li>Identity</li>
                <li>Company</li>
                <li>Contact</li>
                <li>Technical</li>
                <li>Usage</li>
                <li>Profile</li>
                <li>Marketing and Communications</li>
              </ol>
            </td>
            <td>
              Necessary for PROM&apos;s legitimate interests (to develop
              products/services and grow the business){" "}
            </td>
          </tr>
        </table>
        <h3>8.2 Marketing </h3>
        <p>
          If you have given your consent, PROM may use the collected information
          to send you marketing communications, including but not limited to
          general newsletters and individual service offers. The lawful basis
          for this use of personal data is art. 6(1)(a) of GDPR. If you no
          longer wish to receive these Emails, you may opt out of them at any
          point.
        </p>
        <h3>8.3 Promotional Offers</h3>
        <p>
          PROM may use Your Identity, Contact, Technical, Usage and Profile Data
          to form a view on what You may want or need, or what may be of
          interest to You. This is how PROM decides which products, services,
          and offers may be relevant for You.
        </p>
        <p>
          You will receive marketing communications from PROM if You have
          requested information from PROM or purchased goods or services from
          PROM and You have not opted out of receiving promotional offers.
        </p>
        <h3>8.4 Third-party marketing </h3>
        <p>
          PROM will get Your express opt-in consent before sharing Your personal
          data with any third party for marketing purposes.
        </p>
        <h3>8.5 Opting out </h3>
        <p>
          You can ask PROM or third parties to stop sending You marketing
          messages at any time by following the opt-out links on any marketing
          message or by contacting PROM at any time. Where You opt out of
          receiving these marketing messages, this will not apply to personal
          data provided to PROM as a result of a product/service purchase, or
          other transactions.
        </p>
        <h3>8.6 Cookies</h3>
        <p>
          You can set Your browser to refuse all or some browser cookies, or to
          alert You when websites set or access cookies. If You disable or
          refuse cookies, some parts of this website may become inaccessible or
          not function properly. For more information about the cookies used by
          PROM, please see section 7.2 of this policy.
        </p>
        <h3>8.7 Change of Purpose</h3>
        <p>
          PROM will only use Your personal data for the purposes for which they
          were collected, unless PROM reasonably considers that there is a need
          to use it for another reason and that this reason is compatible with
          the original purpose. If You wish to get an explanation as to how the
          processing for the new purpose is compatible with the original
          purpose, please contact PROM at info@prom.io. If PROM needs to use
          Your personal data for an unrelated purpose, PROM will notify You and
          explain the lawful basis which allows PROM to do so.
        </p>
        <h3>8.8 Use without Knowledge or Consent</h3>
        <p>
          PROM may disclose your information where required to do so by law, if
          subject to subpoena or other legal proceeding or if PROM reasonably
          believes that such action is necessary to comply with the law and the
          reasonable requests of law enforcement, to enforce the Terms of
          Service or to protect the security or integrity of the Platform and to
          exercise or protect the rights, property, or personal safety of PROM,
          its users or others.
        </p>
        <h1>9. Disclosures of Your Personal Data </h1>
        <h3>9.1 General Disclosures</h3>
        <p>
          PROM may share Personally Identifiable Information about You with the
          parties set out in this policy for the purposes set out in section
          8.1. PROM may also share “non-PII”, including but not limited to
          general anonymous usage data, referring/exit pages, visited URLs, used
          platform types and number of clicks with third parties to provide them
          with data about usage patterns for certain services. Such non-PII may
          be stored indefinitely.
        </p>
        <h3>9.2 Change of Control </h3>
        <p>
          PROM may buy or sell/divest/transfer the company (including any shares
          in the company), or any combination of its products, services, assets
          and/or businesses. Your information such as usernames and Email
          addresses, and other user information related to the Platform may be
          among the items sold or otherwise transferred in these types of
          transactions. PROM may also sell, assign, or otherwise transfer such
          information in the course of corporate divestitures, mergers,
          acquisitions, bankruptcies, dissolutions, reorganizations,
          liquidations, similar transactions or proceedings involving all or a
          portion of the company. You will be notified by Email of any change in
          ownership or uses of your personal information, as well as any choices
          you may have regarding your personal information.
        </p>
        <h3>9.3 Third Party Restrictions</h3>
        <p>
          PROM requires all third parties to respect the security of Your
          personal data and to treat it in accordance with the law. PROM does
          not allow its third-party service providers to use Your personal data
          for their own purposes and only permit them to process Your personal
          data for specified purposes and in accordance with the regulations and
          guidelines set forth by PROM.{" "}
        </p>
        <h1>10. International Transfer of Data </h1>
        <p>
          Your personal data may be stored and processed in the British Virgin
          Islands (BVI) and any other country in which PROMTECH or its
          subsidiaries, affiliates, or service providers maintain facilities.
          PROMTECH may transfer collected information, including but not limited
          to Personally Identifiable Information (PII), to affiliated entities
          or other third parties across borders and between countries or
          jurisdictions worldwide.
          <p>
            When transferring Your personal data internationally, PROMTECH
            ensures that it is protected to the same extent as required by
            applicable laws in the BVI or by international privacy standards.
            PROMTECH will use one or more of the following legal safeguards for
            data protection during international transfers:
          </p>
        </p>
        <ul>
          <li>
            Transfer it to a country or jurisdiction with privacy laws that
            provide adequate protection for personal data comparable to the
            protections under international data protection standards. Enter
            into a contract with the recipient that requires them to protect
            Your personal data to the same standards as required by
            international privacy frameworks.
          </li>
          <li>
            For transfers of Your personal data to jurisdictions such as the
            United States, PROMTECH relies on recognized legal mechanisms, such
            as the “Trans-Atlantic Data Privacy Framework” or other applicable
            frameworks, to ensure Your data&apos;s security. If You have
            questions regarding how Your data is protected during international
            transfers, please contact PROMTECH at dpo@prom.io.
          </li>
        </ul>
        <h1>11. Data security</h1>
        <p>
          PROM ensures highest standards of data protection technologies and
          methods to be applied at all stages of collecting, processing, and
          storing your personal data. The Platform is protected by the Secure
          Sockets Layer (SSL) protocol which encrypts any personal information
          you enter into registration/login forms before it is sent from your
          computer to the Platform while all user data are stored on the PROM
          servers using the latest encryption technologies.
        </p>
        <p>
          In addition, PROM limits access to Your personal data to those
          employees, agents, contractors and other third parties necessary. They
          will only process Your personal data as instructed by PROM and they
          are subject to a duty of confidentiality.
        </p>
        <p>
          Notwithstanding the aforesaid PROM cannot ensure or warrant the
          security of any information you transmit to PROM or guarantee that
          your information on the Platform may not be accessed, disclosed,
          altered, or destroyed by breach of any of PROM&apos;s industry
          standard physical, technical, or managerial safeguards.
        </p>
        <p>
          In the event that personal information is compromised as a breach of
          security, PROM will promptly notify You in compliance with the
          applicable law.
        </p>
        <p>
          If you have any questions about security on the Platform, please
          contact PROM at info@prom.io.
        </p>
        <h1>12. Data Retention</h1>
        <p>
          For the purpose of maintenance and administration of a business
          relationship with the User, correspondence with the User, assessment
          of the User&apos;s needs, consultation, Prom will store information
          for the period of our continuing business relationship and later on
          for 5 years from the date of termination of our business relationship.
        </p>
        <p>
          This time limit may be additionally extended if a competent authority
          conducts an investigation and the further data processing is necessary
          to execute it or if the Platform feels necessary to maintain data
          longer, especially, due to the nature of its business or business
          relationship.
        </p>
        <p>
          In some circumstances You can ask PROM to delete Your data (see
          section 13).
        </p>
        <p>
          In some circumstances PROM will anonymize Your personal data (so that
          it can no longer be associated with You) for research or statistical
          purposes, in which case PROM may use this information indefinitely
          without further notice to You.
        </p>
        <h1>13. Your Legal Rights about Your Data</h1>
        <h3>13.1 Your Legal Rights </h3>
        <p>
          Under certain circumstances, You have rights under data protection
          laws in relation to Your personal data:
        </p>
        <ul>
          <li>Request access to Your personal data.</li>
          <li>Request correction of Your personal data.</li>
          <li>Request erasure of Your personal data.</li>
          <li>Object to processing of Your personal data.</li>
          <li>Request restriction of processing Your personal data.</li>
          <li>Request transfer of Your personal data.</li>
          <li>Right to withdraw consent.</li>
        </ul>
        <h3>13.2 Exercising Your Rights</h3>
        <p>
          To exercise any of these rights or if You have any questions about
          Your rights under data protection law, please contact the PROMTECH
          Data Protection Officer (DPO): Attn. Data Protection Officer PROMTECH
          SOLUTIONS LTD 1st Floor, Columbus Centre, PO Box 2283 Road Town,
          Tortola VG 1110, British Virgin Islands Email: dpo@prom.io
        </p>
        <h3>13.3 Requirements and Limitations</h3>
        <p>
          PROM may need to request specific information from You to help
          confirming Your identity and ensure Your right to access Your personal
          data (or to exercise any of Your other rights). This is a security
          measure to ensure that personal data is not disclosed to any person
          who has no right to receive it. PROM may also contact You to ask You
          for further information in relation to Your request to speed up our
          response.{" "}
        </p>
        <p>
          You will not have to pay a fee to access Your personal data (or to
          exercise any of the other rights). However, PROM may charge a
          reasonable fee if Your request is clearly unfounded, repetitive, or
          excessive. Alternatively, PROM may refuse to comply with Your request
          in these circumstances.{" "}
        </p>
        <h3>13.4 Response Time</h3>
        <p>
          PROM will try to respond to all legitimate requests within one month.
          Occasionally it could take longer than a month if Your request is
          particularly complex or if You have made a number of requests. In this
          case, PROM will notify You and keep You updated.
        </p>
        <h1>14. Third-party links</h1>
        <p>
          The Platform may include links to third-party websites, plug-ins, and
          applications. Clicking on those links or enabling those connections
          may allow third parties to collect or share data about You. PROM has
          no control over third-party websites and is not responsible for their
          privacy statements. When You leave the Platform, PROM encourages You
          to read the Privacy Policy of every website You visit to ensure the
          safety of Your personal data.
        </p>
        <h1>15. Changes to the Privacy Policy</h1>
        <p>
          All changes to this Privacy Policy are effective when they are posted
          on this page. If PROM changes the policy in a material manner, PROM
          will notify its users via Email and/or a prominent notice on the
          Platform, prior to the change becoming effective and update the
          &apos;effective date&apos; at the bottom of this page.
        </p>
        <h1>16. Definitions </h1>
        <h3>16.1 LAWFUL BASIS </h3>
        <p>
          <b>Legitimate Interest </b>means the interest of PROM in conducting
          and managing its business to provide You with the best and the most
          secure services/products and customer experience. PROM considers and
          balances any potential impact on You (both positive and negative) and
          Your rights before processing Your personal data for the legitimate
          interests of PROM. Your personal data will not be used for activities
          where the interests of PROM are overridden by the impact on You
          (unless PROM has Your written consent or is otherwise required or
          permitted to by law). You can obtain further information about how
          PROM is assessing its legitimate interests against any potential
          impact on You in respect of specific activities by contacting PROM at
          dpo@prom.io.{" "}
        </p>
        <p>
          <b>Performance of Contract </b>means processing Your data where it is
          necessary for the performance of a contract to which You are a party
          or to take steps at Your request before entering into such a contract.{" "}
        </p>
        <p>
          <b>Compliance with a legal obligation </b>means processing Your
          personal data where it is necessary for compliance with a legal
          obligation that PROM is subject to.
        </p>
        <h3>16.2 YOUR LEGAL RIGHTS</h3>
        <p>You have the right to:</p>
        <p>
          <b>Request access </b>to Your personal data (commonly known as a
          &quot;data subject access request&quot;). This enables You to receive
          a copy of the personal data PROM holds about You and to check that
          PROM is lawfully processing it.{" "}
        </p>
        <p>
          <b>Request correction </b>
          of the personal data that PROM holds about you. That enables You to
          have any incomplete or inaccurate data corrected, though PROM may need
          to verify the accuracy of the new data You provide to PROM.
        </p>
        <p>
          <b>Request erasure </b>of Your personal data. This enables You to ask
          PROM to delete or remove personal data where there are no grounds for
          PROM continuing to process it. You also have the right to ask PROM to
          delete or remove Your personal data where You have successfully
          exercised Your right to object to processing (see below), where PROM
          may have processed Your information unlawfully or where PROM is
          required to erase Your personal data to comply with local legislation.
          PROM is not obliged to comply with Your request of erasure in case of
          opposing legal regulations, which will be notified to You, if
          applicable, at the time of Your request.{" "}
        </p>
        <p>
          <b>Object to processing </b>of Your personal data where PROM is
          relying on a legitimate interest (or those of a third party) and there
          is something about Your particular situation which makes You want to
          object to processing on this basis as You have reasonable grounds to
          assume it impacts Your fundamental rights and freedoms. You also have
          the right to object where PROM is processing Your personal data for
          direct marketing purposes. In some cases, PROM may demonstrate
          evidence of compelling legitimate grounds to process Your information
          which override Your rights and freedoms.{" "}
        </p>
        <p>
          <b>Request restriction of processing </b>of Your personal data. This
          enables You to ask PROM to suspend the processing of Your personal
          data in the following cases:
        </p>
        <ul>
          <li>You want PROM to establish the data&apos;s accuracy.</li>
          <li>
            PROM&apos;s use of the data is unlawful, but You do not want PROM to
            erase it.
          </li>
          <li>
            You need PROM to hold the data even if PROM no longer requires it as
            You need it to establish, exercise or defend legal claims.
          </li>
          <li>
            You have objected to PROM&apos;s use of Your data, but PROM needs to
            verify whether there are overriding legal grounds to use it.
          </li>
        </ul>
        <p>
          <b>Request the transfer </b>of Your personal data to You or to a third
          party. Upon your request, PROM will provide to You, or a third party
          You have chosen, Your personal data in a structured, commonly used,
          machine-readable format. This right applies only to automated
          information which You initially provided consent for PROM to use or
          where PROM used the information to perform a contract with You.
        </p>
        <p>
          <b>Withdraw consent at any time </b>where we are relying on consent to
          process Your personal data. The use of this right will not affect the
          lawfulness of any processing carried out before the withdrawal of Your
          consent. If You withdraw Your consent, PROM may not be able to provide
          certain products or services to You. PROM will advise You if this is
          the case at the time of Your withdrawal of consent.{" "}
        </p>
        <p>PROMTECH SOLUTIONS LTD</p>
        <p>Privacy Policy V1.1</p>
        <p>Effective Date: 25th November 2024 </p>
      </Container>
    </>
  );
};
